import { Controller } from "stimulus"

const BACKDROP_CLASS = 'posthog-survey-backdrop'
const SUPPRESSING_MODAL_IDS = ['copilot-modal']

export default class extends Controller {

  connect() {
    this.pendingSurveyElement = null
    this.handleModalHidden = this.handleModalHidden.bind(this)
    document.addEventListener('modal:hidden', this.handleModalHidden)
    this.applySurveyStyles();
  }

  disconnect() {
    this.observer?.disconnect()
    document.removeEventListener('modal:hidden', this.handleModalHidden)
    this.removeBackdrop()
  }

  handleModalHidden(event) {
    if (!SUPPRESSING_MODAL_IDS.includes(event.detail?.id)) return
    if (this.pendingSurveyElement && !this.isAnySuppressingModalOpen()) {
      this.revealSurvey(this.pendingSurveyElement)
      this.pendingSurveyElement = null
    }
  }

  isAnySuppressingModalOpen() {
    return SUPPRESSING_MODAL_IDS.some((id) => {
      const modalRoot = document.querySelector(`[data-modal-id-value="${id}"] [data-modal-target="modal"]`)
      return !!modalRoot && getComputedStyle(modalRoot).display !== 'none'
    })
  }

  applySurveyStyles(){
    const targetNode = document.body
    const config = { attributes: true, childList: true, subtree: true };
    this.observer = new MutationObserver(() => {
      const surveyElement = document.querySelector('[class^="PostHogSurvey"]')
      if (!surveyElement) {
        this.removeBackdrop()
        this.pendingSurveyElement = null
        return
      }

      // Defer the survey while any modal in SUPPRESSING_MODAL_IDS is open so the
      // two never overlap; handleModalHidden reveals it once none remain open.
      if (this.isAnySuppressingModalOpen()) {
        surveyElement.style.display = 'none'
        this.removeBackdrop()
        this.pendingSurveyElement = surveyElement
        return
      }

      this.revealSurvey(surveyElement)
    });
    this.observer.observe(targetNode, config)
  }

  revealSurvey(surveyElement) {
      surveyElement.style.display = 'block';
      surveyElement.style.position = 'relative';
      surveyElement.style.zIndex = '2147483647';
      this.addBackdrop()

      const shadowRoot = surveyElement.shadowRoot;
      if (!shadowRoot) {
        return;
      }

      const style = document.createElement('style');
      const surveyForm = shadowRoot.querySelector('.survey-form');
      if (surveyForm && surveyForm.parentElement) {
        surveyForm.parentElement.classList.add('survey-form-container');
      }

      if (surveyElement.dataset.saverlifeStyled === 'true') {
        return;
      }
      surveyElement.dataset.saverlifeStyled = 'true'

      style.textContent = `
          .survey-form-container {
            bottom: 50px;
            border-bottom: 1.5px solid #c01489;
            border-radius: 10px;
          }

          .thank-you-message {
            border-radius: 10px;
          }
    
          .survey-form {
            border-radius: 10px;
          }
    
          @media (max-width: 767px) {
            .survey-form-container {
              right: unset !important;
              left: 50% !important;
              top: 50% !important;
              bottom: unset !important;
              transform: translate(-50%, -50%) !important;
              width: 325px !important;
              max-width: calc(100vw - 32px) !important;
            }

            .survey-form,
            .thank-you-message {
              width: 100% !important;
              max-width: none !important;
            }
          }
        `;

      shadowRoot.appendChild(style);
  }

  addBackdrop() {
    if (document.querySelector(`.${BACKDROP_CLASS}`)) return

    const backdrop = document.createElement('div')
    backdrop.className = BACKDROP_CLASS
    document.body.appendChild(backdrop)
  }

  removeBackdrop() {
    document.querySelector(`.${BACKDROP_CLASS}`)?.remove()
  }
}
